import * as React from 'react';
import { IconProps } from './types';

export function DownIcon(props: IconProps) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} viewBox="0 0 14 8" fill="none">
			<path d="M13 1L7.70711 6.29289C7.37377 6.62623 7.20711 6.79289 7 6.79289C6.79289 6.79289 6.62623 6.62623 6.29289 6.29289L1 1" stroke={props.stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
}
